import React from 'react';
import {Container} from 'react-bootstrap';


export const WhoAmI = () => {
    return (
        <Container style={styles.contentStyle}> 
            <div style={{marginBottom: '10vh', marginTop: '10vh'}}>
                <h2> Hello there, I am a Software Developer.</h2>
                <h4>
                    I recently finished my B.S. in Informatics and Computer Science,
                    <br/> 
                    from the University of Strathmore
                    contact me at... 
                    <br/> 
                    <strong>jaden.lesuk@gmail.com</strong>
                </h4>
                
            </div>
        </Container>
    )
}

const styles = {
    contentStyle: {
        // display: 'flex',
        // justifyContent: 'center',
        // alignItems: 'center',
        color: 'white', 
        // // marginBottom:'10vh', 
        // // marginTop: '100vh',
        // height: '25vh',
        textAlign: 'center',
    }
}
